import { render, staticRenderFns } from "./Pm2Table.vue?vue&type=template&id=74d38dd0&scoped=true&"
import script from "./Pm2Table.vue?vue&type=script&lang=ts&"
export * from "./Pm2Table.vue?vue&type=script&lang=ts&"
import style0 from "./Pm2Table.vue?vue&type=style&index=0&id=74d38dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d38dd0",
  null
  
)

export default component.exports